import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Lubusz() {
  return (
    <>
      <DisplayMaster voivodeship="Lubusz" />
    </>
  );
}